import { render, staticRenderFns } from "./PrintLabel.vue?vue&type=template&id=4361fae3&"
import script from "./PrintLabel.vue?vue&type=script&lang=js&"
export * from "./PrintLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports